import { ApiErrorCode, type ApiResponse, withApiErrorHandler } from '@/modules/common/api/errors';
import type { TimeOffBalance } from '@/modules/time-off/types';
import { axiosInstance } from '@/utils/axios';

import { mapTimeOffBalanceFromDTO } from '../mappers/time-off-balance.mapper';
import { mapTimeOffRequestDetailsFromDTO } from '../mappers/time-off-request-details.mapper';
import type {
  AdjustTimeOffBalanceRequest,
  TimeOffBalanceSummaryItemResponse,
} from '../types/dto/time-off-balance.dto';
import type { TimeOffRequestDetailsResponse } from '../types/dto/time-off-request-details.dto';
import type { TimeOffRequestDetails } from '../types/time-off-request-details';

export const getMemberTimeOffBalances = async (memberId: string): Promise<TimeOffBalance[]> => {
  const endpoint = `/api/team/members/${encodeURIComponent(memberId)}/time-off/balances`;

  const response = await withApiErrorHandler(endpoint, ApiErrorCode.GENERIC_ERROR, () =>
    axiosInstance.get<ApiResponse<TimeOffBalanceSummaryItemResponse[]>>(endpoint)
  );

  return response.map(mapTimeOffBalanceFromDTO);
};

export const getMemberTimeOffRequestDetails = async ({
  requestId,
}: {
  memberId: string;
  requestId: number;
}): Promise<TimeOffRequestDetails> => {
  const endpoint = `/api/time-off/requests/${requestId}/details`;

  const response = await withApiErrorHandler(endpoint, ApiErrorCode.GENERIC_ERROR, () =>
    axiosInstance.get<ApiResponse<TimeOffRequestDetailsResponse>>(endpoint)
  );

  return mapTimeOffRequestDetailsFromDTO(response);
};

export const adjustMemberTimeOffBalance = async (
  payload: AdjustTimeOffBalanceRequest
): Promise<{ success: true }> => {
  const endpoint = '/api/time-off/balances/adjust';

  await withApiErrorHandler(endpoint, ApiErrorCode.GENERIC_ERROR, () =>
    axiosInstance.post<ApiResponse<void>>(endpoint, payload)
  );

  return { success: true };
};
